<template>
  <div>
    <div v-loading="tree_config.loading">
      <p class="font-16 font-bold">菜单权限：</p>
      <el-tree
        ref="menuTree"
        class="tree"
        :data="tree_config.menu_config.options"
        node-key="id"
        show-checkbox
        :props="tree_config.props"
      />
      <p class="font-16 font-bold">功能权限：</p>
      <el-tree
        ref="apiTree"
        class="tree"
        :data="tree_config.api_config.options"
        node-key="id"
        show-checkbox
        :props="tree_config.props"
      />
    </div>
    <div class="text-right">
      <el-button size="mini" @click="cancel">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
    </div>
  </div>
</template>

<script>
import RolesResource from '@/api/roles';
const rolesResource = new RolesResource();
import PermissionsResource from '@/api/permissions';
const permissionsResource = new PermissionsResource();

export default {
  props: {
    data: { type: Object, default: null },
  },
  data() {
    return {
      tree_config: {
        loading: false,
        props: {
          children: 'children',
          label: 'name',
        },
        menu_config: {
          options: [],
        },
        api_config: {
          options: [],
        },
      },
    };
  },
  computed: {
    /** 获取菜单权限非父节点的节点 */
    getMenuChildNode() {
      const menu = this.data.permissions.menu;
      return menu.filter(m => !(menu.find(e => m.id === e.parent_id)));
    },
    /** 获取功能权限非父节点的节点 */
    getApiChildNode() {
      const api = this.data.permissions.api;
      return api.filter(m => !(api.find(e => m.id === e.parent_id)));
    },
  },
  created() {
    this.getPermissionList();
  },
  methods: {
    getPermissionList() {
      this.tree_config.loading = true;
      permissionsResource.getApi().then(({ menu: { list: menu_list }, api: { list: api_list }}) => {
        const { menu_config, api_config } = this.tree_config;
        Object.assign(menu_config, { options: menu_list });
        Object.assign(api_config, { options: api_list });
        this.$nextTick(() => {
          this.$refs.menuTree.setCheckedNodes(this.getMenuChildNode);
          this.$refs.apiTree.setCheckedNodes(this.getApiChildNode);
          this.tree_config.loading = false;
        });
      });
    },
    confirm() {
      this.tree_config.loading = true;
      const menu_checked = this.$refs.menuTree.getCheckedNodes(false, true).map(({ id }) => id);
      const api_checked = this.$refs.apiTree.getCheckedNodes(false, true).map(({ id }) => id);
      rolesResource.editApi({ permissions: [...menu_checked, ...api_checked] }, this.data.id).then(() => {
        this.$message.success('更新成功！');
        this.tree_config.loading = false;
        this.$emit('comfirm');
      });
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
